var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafeInfoLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#1C1C1C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.2029 24.9976H36.4681C35.3526 24.9976 34.4488 25.9016 34.4488 27.0173V32.4393C34.4488 33.555 33.545 34.4591 32.4295 34.4591H17.5713C16.4558 34.4591 15.552 35.3631 15.552 36.4788V40.2144C15.552 41.3301 16.4558 42.2342 17.5713 42.2342H33.2895C34.405 42.2342 35.296 41.3301 35.296 40.2144V37.2173C35.296 36.1016 36.1998 35.3102 37.3152 35.3102H40.2021C41.3175 35.3102 42.2214 34.4061 42.2214 33.2905V26.9939C42.2214 25.8782 41.3175 24.9976 40.2021 24.9976H40.2029Z",
    fill: "#636669"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5512 17.5761C15.5512 16.4604 16.455 15.5564 17.5705 15.5564H32.4196C33.5351 15.5564 34.4389 14.6523 34.4389 13.5366V9.80099C34.4389 8.6853 33.5351 7.78125 32.4196 7.78125H16.7097C15.5943 7.78125 14.6904 8.6853 14.6904 9.80099V12.6794C14.6904 13.7951 13.7866 14.6992 12.6711 14.6992H9.79712C8.68167 14.6992 7.77783 15.6032 7.77783 16.7189V23.0223C7.77783 24.138 8.68545 24.9967 9.8009 24.9967H13.5357C14.6511 24.9967 15.555 24.0926 15.555 22.977L15.5512 17.5769V17.5761Z",
    fill: "#636669"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.242 21.0706H26.8294C27.9985 21.0706 28.947 22.02 28.947 23.1886V26.7768C28.947 27.9462 27.9978 28.8948 26.8294 28.8948H23.242C22.0729 28.8948 21.1245 27.9454 21.1245 26.7768V23.1886C21.1245 22.0192 22.0737 21.0706 23.242 21.0706Z",
    fill: "#636669"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafeInfoLogoDark);
export default __webpack_public_path__ + "static/media/safe-info-logo-dark.2f97a99fbb2683bc6146ae42ecc3d05e.svg";
export { ForwardRef as ReactComponent };